import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import GraficoViewer from '../views/GraficoViewer.vue';
import ColecoesNascimentos from '../views/ColecoesNascimentos.vue';
import PedidosCertidoes from '../views/PedidosCertidoes.vue';

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
    },
    {
        path: '/:forcedPath',
        component: GraficoViewer,
        props: true
    },
    {
        path: '/registrese',
        component: GraficoViewer,
        props: { id: '534' },
    },
    {
        path: '/casamentos',
        component: GraficoViewer,
        props: { id: '567' },
    },
    {
        path: '/obitos',
        component: GraficoViewer,
        props: { id: '568' },
    },
    {
        path: '/mudanca-genero',
        component: GraficoViewer,
        props: { id: '570' },
    },
    {
        path: '/uniao-estavel',
        component: GraficoViewer,
        props: { id: '535' },
    },
    {
        path: '/unidades-interligadas',
        component: GraficoViewer,
        props: { id: '533' },
    },
    {
        path: '/colecoes-nascimentos',
        component: ColecoesNascimentos,
        props: { id: null },
    },
    {
        path: '/registros-tardios',
        component: GraficoViewer,
        props: { id: '578' },
    },
    {
        path: '/orfaos',
        component: GraficoViewer,
        props: { id: '579' },
    },
    {
        path: '/nascimentos',
        component: GraficoViewer,
        props: { id: '565' },
    },
    {
        path: '/carga-legado',
        component: GraficoViewer,
        props: { id: '569' }
    },
    {
        path: '/pedidos-certidoes',
        component: PedidosCertidoes,
        props: { id: null },
    },
    {
        path: '/prazo-medio-emissao',
        component: GraficoViewer,
        props: { id: '585' },
    },
];

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes,
});

export default router;
